import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/pro-light-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

import styles from './styles.module.scss'

const renderText = (timer: number) => {
  if (timer < 5) return 'Resizing Images'
  if (timer < 8) return 'Compressing Images'
  if (timer < 11) return 'Preparing Download of Images'

  return 'Downloading and Preparing Link'
}

const ProcessingMessage = (props: { timer: number }) => {
  const { timer } = props

  return (
    <>
      <Box
        flexDirection="column"
        lineHeight="1.3"
        marginBottom="large"
        padding="large"
        variant="whiteGrey"
      >
        <Text fontSize="small">Hang tight!</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          We&apos;re just resizing your images for you now. Depending on your
          requested size we will take the original images and make them more
          appropriately sized for your uses.
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          Please wait while we complete your request
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          Larger image libraries will take a little bit longer, but it should only
          take a few moments. If you experience any issues please contact support.
        </Text>
      </Box>

      <Box alignItems="center" color="bodyFontLightColor" padding="large" variant="white">
        <FontAwesomeIcon icon={faSpinner} className={styles.spinner} />

        <Text color="bodyFontLightColor" fontSize="small">{renderText(timer)}</Text>
      </Box>
    </>
  )
}

export default ProcessingMessage
